import classNames from "classnames";
import React from "react";
import { Link, Icon, Icomoon } from "../..";

export interface LinkButtonProps extends React.HTMLProps<HTMLAnchorElement> {
  icomoon?: Icomoon | string;
  iconAlign?: "right" | "left";
  to: string;
  buttonClass?: "primary-button" | "secondary-button";
}

/**
 * It looks like a button, but it's actually a link! Mainly used in the marketing site as CTAs for navigation between pages.
 * @status stable
 */
export const LinkButton: React.FC<LinkButtonProps> = (props) => {
  const { children, className, to, icomoon, iconAlign, buttonClass, ...htmlProps } = props;

  const leftIcon = (iconAlign === "left" && icomoon) && (
    <Icon className="left-icon" icomoon={icomoon as Icomoon} />
  );

  const rightIcon = (iconAlign === "right" && icomoon) && (
    <Icon className="right-icon" icomoon={icomoon as Icomoon} />
  );

  return (
    <Link
      to={to}
      className={classNames(buttonClass, className)}
      {...htmlProps}
    >
      <span>
        {leftIcon}
        {children}
        {rightIcon}
      </span>
    </Link>
  );
}

LinkButton.defaultProps = {
  iconAlign: "left",
  buttonClass: "primary-button"
};

LinkButton.displayName = "LinkButton";

export default LinkButton;

